import { gql } from '@apollo/client';

export const OPEN_ORDER = gql`
  mutation OpenOrder(
    $products: [ProductInput]!
    $orderType: String!
    $orderDetails: OrderDetailsInput!
  ) {
    openOrder(
      products: $products
      orderType: $orderType
      orderDetails: $orderDetails
    ) {
      id
      status
      invoice {
        id
        lineItems {
          id
          priceId
          quantity
          amount
          productName
        }
        total
      }
    }
  }
`;

export const APPLY_PROMO_CODE_TO_ORDER = gql`
  mutation ApplyPromoCodeToOrder($orderId: String!, $promoCode: String!) {
    applyPromoCodeToOrder(orderId: $orderId, promoCode: $promoCode) {
      id
      status
      promoCode
      invoice {
        id
        lineItems {
          id
          priceId
          quantity
          amount
          discount
          productName
        }
        total
        discount {
          name
          amount
        }
      }
    }
  }
`;

export const ADD_ON_TO_ORDER = gql`
  mutation AddOnToOrder($orderId: String!, $product: ProductInput!) {
    addOnToOrder(orderId: $orderId, product: $product) {
      id
      status
      promoCode
      invoice {
        id
        lineItems {
          id
          priceId
          quantity
          amount
          discount
          productName
        }
        total
        discount {
          name
          amount
        }
      }
    }
  }
`;

export const REMOVE_FROM_ORDER = gql`
  mutation RemoveFromOrder($orderId: String!, $product: ProductInput!) {
    removeFromOrder(orderId: $orderId, product: $product) {
      id
      status
      promoCode
      invoice {
        id
        lineItems {
          id
          priceId
          quantity
          amount
          discount
          productName
        }
        total
        discount {
          name
          amount
        }
      }
    }
  }
`;

export const COMPLETE_ORDER = gql`
  mutation CompleteOrder(
    $orderId: String!
    $pmId: String!
    $includeEmail: Boolean
    $includeIP: Boolean
    $includePhone: Boolean
    $distributionConfigs: [DistributionConfigInput]
    $alsoOrderProfile: Boolean
    $profileProducts: [ProductInput]
  ) {
    completeOrder(
      orderId: $orderId
      pmId: $pmId
      includeEmail: $includeEmail
      includeIP: $includeIP
      includePhone: $includePhone
      distributionConfigs: $distributionConfigs
      alsoOrderProfile: $alsoOrderProfile
      profileProducts: $profileProducts
    ) {
      id
      profileOrderId
    }
  }
`;
